type Lut<N extends number = 256, R extends number[] = []> = R['length'] extends N
  ? R[number]
  : Lut<N, [...R, R['length']]>;
type LutArray<N extends number = 256, R extends string[] = []> = R['length'] extends N
  ? R
  : LutArray<N, [string, ...R]>;

class UUID {
  private readonly lut = new Array(256) as LutArray;
  constructor() {
    let i = 0;
    while (i < 16) {
      this.lut[i] = '0' + (i++).toString(16);
    }
    while (i < 256) {
      this.lut[i] = (i++).toString(16);
    }
  }
  v4(): string {
    const d0 = (Math.random() * 0xffffffff) | 0;
    const d1 = (Math.random() * 0xffffffff) | 0;
    const d2 = (Math.random() * 0xffffffff) | 0;
    const d3 = (Math.random() * 0xffffffff) | 0;
    return (
      this.lut[(d0 & 0xff) as Lut] +
      this.lut[(d0 >> 8) & 0xff] +
      this.lut[(d0 >> 16) & 0xff] +
      this.lut[(d0 >> 24) & 0xff] +
      '-' +
      this.lut[d1 & 0xff] +
      this.lut[(d1 >> 8) & 0xff] +
      '-' +
      this.lut[((d1 >> 16) & 0x0f) | 0x40] +
      this.lut[(d1 >> 24) & 0xff] +
      '-' +
      this.lut[(d2 & 0x3f) | 0x80] +
      this.lut[(d2 >> 8) & 0xff] +
      '-' +
      this.lut[(d2 >> 16) & 0xff] +
      this.lut[(d2 >> 24) & 0xff] +
      this.lut[d3 & 0xff] +
      this.lut[(d3 >> 8) & 0xff] +
      this.lut[(d3 >> 16) & 0xff] +
      this.lut[(d3 >> 24) & 0xff]
    );
  }
}
export const uuid = new UUID();
